import { render, staticRenderFns } from "./FreightTable.vue?vue&type=template&id=0075df2a&"
import script from "./FreightTable.vue?vue&type=script&lang=js&"
export * from "./FreightTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports